import React from 'react';
import { formatTimestamp } from '../Pc-and-Large-Screens/utils/ChatUtils';

const Message = ({ message }) => (
  <div className={`message ${message.type === 'incoming' ? 'incoming' : 'outgoing'}`}>
    <span className="message-text">{message.text}</span>
    <span className="timestamp">{formatTimestamp(message.timestamp)}</span>
  </div>
);

export default Message;
